import React from 'react';
import { motion } from 'framer-motion';
import './cta.css';

const CTA = () => {
    return (
        <motion.div
            className='gpt3__cta'
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
        >
            <div className='gpt3__cta-content'>
                <p>Professional ECU Remapping & IMMO Bypass Solutions</p>
                <h3>Shop our professional ECU tools or request a custom-built software solution for Nissan, Kia, and Hyundai.</h3>
            </div>

            <div className='gpt3__cta-btn'>
                <a href="https://wa.me/966590707424" target="_blank" rel="noreferrer">
                    <button type='button'>Get in Touch</button>
                </a>
            </div>
        </motion.div>
    )
}

export default CTA
